import { JWTAuth } from "../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../lib/js-apiclient/src/AdvancedApiClient";

export class PosAnalyticsApiClient extends AdvancedApiClient {

    static entityType = "PosData"

    constructor(token, type = "avg_score", group = "day") {
        super();

        this.setEntityType(PosAnalyticsApiClient.entityType)
        this.setRoute("/api/v1/analytics/pos/{type}/{group}")
            .setRouteParam("type", type)
            .setRouteParam("group", group)
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}